(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/shared-components/header-text.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/shared-components/header-text.js');

'use strict';

const HeaderText = () => React.createElement("div", {
  className: "align-center"
}, React.createElement("h1", {
  className: "padding-top-2 h1 margin-bottom-1"
}, React.createElement("span", {
  className: "f-medium login-react-am-h0"
}, "V\xE4lkommen till", React.createElement("br", null), ' ', "Svenska Spel Tur!")));
svs.playerLoginReact.sharedComponents.HeaderText = HeaderText;

 })(window);